"use strict";
(function(global) {
    class PaloAltoController {
        constructor(config) {
            this.settings = {
                charts: {
                    pieCharts: {
                        alertsByFileType: {
                            id: "summaryByFileType",
                            dataName: "summary_by_file_type"
                        },
                        alertsByHarmfulnessSample: {
                            id: "summaryByHarmfulnessSample",
                            dataName: "summary_by_harmfulness_sample"
                        },
                        alertsByStatusAnalysis: {
                            id: "summaryByStatusAnalysis",
                            dataName: "summary_by_status_analysis"
                        }
                    },
                    barChart: {
                        dataName: "column_data",
                        id: "alarms"
                    }
                },
                colors: {
                    low: "250, 220, 0",
                    medium: "255, 132, 51",
                    high: "213, 71, 51"
                }
            };
            this.config = config;
            this.loadDataChart();
            this.createGrid();
        }

        loadDataChart() {
            const loadingDivs = document.querySelectorAll('.loading');
            const cardActions = [];

            for (const div of loadingDivs) {
                const closestCard = div.closest('.card');
                const cardHeaders = closestCard.querySelectorAll('.card-header');

                for (const headerElement of cardHeaders) {
                    const actions = headerElement.querySelectorAll('.actions');
                    cardActions.push(...actions);
                }
            }

            $(document).on('ajaxStart', () => {
                for (const div of loadingDivs) {
                    div.style.display = 'block';
                    div.classList.add('i-am-visible');
                }

                const chartTitleElements = document.querySelectorAll('.chart-title');
                chartTitleElements.forEach(el => el.style.display = 'none');
                cardActions.forEach(el => el.style.opacity = 0);
            });
            $(document).on('ajaxStop', () => {
                for (const div of loadingDivs) {
                    div.classList.add('hide-me');
                    div.addEventListener('transitionend', () => div.style.display = 'none');
                }

                const chartTitleElements = document.querySelectorAll('.chart-title');
                chartTitleElements.forEach(el => el.style.display = 'block');
                cardActions.forEach(el => el.style.opacity = 1);
            });
            const el = document.getElementById('charLinear1');
            const span = el.querySelector('span');
            const div = el.querySelector('div');

            ApiConnect.get(this.config.chart_data_url).then(data => {
                // noinspection JSUnresolvedVariable
                const values = data.data.column_data.values;

                if (Object.keys(values).length === 0 && values.constructor === Object) {
                    span.style.display = 'block';
                } else {
                    div.style.display = 'block';
                    this.drawBarChart(data);
                }

                this.drawPieCharts(data);
                this.setCardHeaders(data);
            }).catch((errorThrown) => {
                console.log('Błąd wczytywania danych: ', errorThrown);
            }).finally(() => {
                for (const div of loadingDivs) {
                    div.classList.add('hide-me');
                    div.addEventListener('transitionend', () => div.style.display = 'none');
                }

                const chartTitleElements = document.querySelectorAll('.chart-title');
                chartTitleElements.forEach(el => el.style.display = 'block');
                cardActions.forEach(el => el.style.opacity = 1);
            });
        }

        setCardHeaders(data) {
            const chartSettings = this.settings.charts;
            const pieChartSettings = chartSettings.pieCharts;
            const barChartId = chartSettings.barChart.id;
            const pieChartKeys = Object.keys(pieChartSettings);
            const firstPieChartSettings = pieChartSettings[pieChartKeys[0]];
            const firstPieChartId = firstPieChartSettings.id;
            const firstPieChartDataName = firstPieChartSettings.dataName;
            const firstPieChartTabId = firstPieChartId + 'Tab';
            const barChart = document.getElementById(barChartId);
            const barChartCard = barChart.closest('.card');
            const barChartTitleEl = barChartCard.querySelector('.chart-title');
            barChartTitleEl.textContent = this.config["bar_chart_title"];

            document.querySelectorAll('.pie-charts .char-tab').forEach(node => node.classList.remove('active'));

            const firstPieChart = document.getElementById(firstPieChartId);
            const pieChartsCard = firstPieChart.closest('.card');
            const pieChartTitleEl = pieChartsCard.querySelector('.chart-title');
            pieChartTitleEl.textContent = data.data[firstPieChartDataName].name;

            const firstPieChartTab = document.getElementById(firstPieChartTabId);
            firstPieChartTab.classList.add('active');

            for (const key of pieChartKeys) {
                const chart = pieChartSettings[key];
                const pieChartMenuEl = document.querySelector('.pie-chart-menu');
                pieChartMenuEl.insertAdjacentHTML('beforeend', '<li><a href="#" data-target-id="' + chart.id + 'Tab" class="char-tab-toggle">' + data.data[chart.dataName].name + '</a></li>');
            }

            this.bindChangeTabPieChart();
        }

        bindChangeTabPieChart() {
            const chartTabToggles = document.querySelectorAll('.char-tab-toggle');

            for (const toggle of chartTabToggles) {
                toggle.addEventListener('click', e => {
                    e.preventDefault();
                    const target = document.getElementById(toggle.getAttribute('data-target-id'));

                    if (target) {
                        const otherTabs = Array.prototype.filter.call(target.parentNode.children, child => {
                            return child !== target;
                        });

                        for (const tab of otherTabs) {
                            tab.classList.remove('active');
                        }

                        target.classList.add('active');
                    }

                    const cardHeader = toggle.closest('.card-header');
                    const chartTitleEl = cardHeader.querySelector('h2');
                    chartTitleEl.textContent = toggle.textContent;
                });
            }
        }

        drawBarChart(data) {
            this.barChart = new NS.Charts.BarChart({
                "container-id": "alarms",
                data: data["data"][this.settings["charts"]["barChart"]["dataName"]],
                multidata: false,
                name_mapping: {
                    val: "Dane",
                },
                show_legend: this.config['show_legend']
            });
        }

        drawPieCharts(data) {
            this.summaryByImportanceChart = new NS.Charts.PieChart({
                "container-id": this.settings["charts"]["pieCharts"]["alertsByHarmfulnessSample"]["id"],
                data: data["data"][this.settings["charts"]["pieCharts"]["alertsByHarmfulnessSample"]["dataName"]],
                show_legend: this.config['show_legend']
            });

            this.summaryByTypeChart = new NS.Charts.PieChart({
                "container-id": this.settings["charts"]["pieCharts"]["alertsByFileType"]["id"],
                data: data["data"][this.settings["charts"]["pieCharts"]["alertsByFileType"]["dataName"]],
                show_legend: this.config['show_legend']
            });

            this.summaryByStatusAnalysisChart = new NS.Charts.PieChart({
                "container-id": this.settings["charts"]["pieCharts"]["alertsByStatusAnalysis"]["id"],
                data: data["data"][this.settings["charts"]["pieCharts"]["alertsByStatusAnalysis"]["dataName"]],
                show_legend: this.config['show_legend']
            });
        }

        createGrid() {
            const columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
                columnDefinitions: [{
                    label: "Czas utworzenia próbki",
                    dataIndex: "create_time",
                    dataType: "text",
                    isEditable: false,
                    isSortable: true,
                    isFilterable: true,
                    isMovable: true,
                }, {
                    label: "IP FW klienta",
                    dataIndex: "client_ip",
                    dataType: "text",
                    isEditable: false,
                    width: "*"
                }, {
                    label: "Model FW klienta",
                    dataIndex: "client_model",
                    dataType: "text",
                    isEditable: false
                }, {
                    label: "Nazwa pliku",
                    dataIndex: "file_name",
                    dataType: "text",
                    isEditable: false
                }, {
                    label: "Typ pliku",
                    dataIndex: "file_type",
                    dataType: "text",
                    isEditable: false
                }, {
                    label: "Rozmiar pliku ",
                    dataIndex: "file_size",
                    dataType: "text",
                    isEditable: false
                }, {
                    label: "Próbka złośliwa",
                    dataIndex: "malicious_sample",
                    dataType: "text",
                    isEditable: false
                }, {
                    label: "Status ",
                    dataIndex: "status",
                    dataType: "text",
                    isEditable: false,
                }, {
                    label: "Akcje",
                    dataIndex: "actions",
                    dataType: "link",
                    isEditable: false,
                    width: 100
                }]
            });

            const dataSource = new NS.Grid.SimpleDataSource({
                url: this.config.table_data_url,
                baseParameters: {},
                updateUrl: "/js/app/update.json"
            });

            const settingsManager = new NS.Grid.CookiesSettingsManager({
                id: "gridContainerId"
            });

            new NS.Grid.Control({
                id: "gridContainerWrapperId",
                containerId: 'grid-container',
                dataSource: dataSource,
                reloadTime: null, //not implemented yet
                autoLoad: true,
                columnDefinitionSource: columnDefinitionSource,
                settingsManager: settingsManager,
                allowMultiselect: false,
                showAllRows: this.config.show_all_rows || false,
                pageSize: (this.config.show_all_rows)? 99999999 : 20,
                listeners: {
                    onDataChanged: () => {},
                    onDataSaved: () => {},
                    onDataInvalid: () => {},
                    onDataError: () => {},
                    onSelectionChange: () => {}
                }
            });
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.PaloAltoController = PaloAltoController || {};

})(window);
